import { render, staticRenderFns } from "./AiAssistanceSection.vue?vue&type=template&id=2be39d7a&scoped=true"
import script from "./AiAssistanceSection.vue?vue&type=script&lang=js"
export * from "./AiAssistanceSection.vue?vue&type=script&lang=js"
import style0 from "./AiAssistanceSection.vue?vue&type=style&index=0&id=2be39d7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be39d7a",
  null
  
)

export default component.exports